// import css
import "~/css/app.pcss";

// import icons
import "~/js/assets/icons.js";

// import App from '~/vue/App.vue'
// import { createApp } from 'vue'
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { addCookieEventListeners } from "~/js/utils/cookie-script";
// import { animateInit } from '~/js/utils/animation.ts'
// animateInit()

// alpine
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
// import navigation from '~/js/alpine/navigation.js'

const navigation = () => ({
	atTop: true,
	activeSubNav: "",
	showMobileNavigation: false,
	debounce(func, wait) {
		const later = function () {
			this.timeout = null;
			func.apply(this, []);
		};
		clearTimeout(this.timeout);
		this.timeout = setTimeout(later, wait);
	},
});

Alpine.data("navigation", navigation);
Alpine.plugin(focus);
Alpine.start();

import { Translations } from "./interfaces/translations";
declare global {
	interface Window {
		language: string;
		translations: Translations;
	}
}

// Main app
const main = async () => {
	// const app = createApp(App)

	const pinia = createPinia();
	pinia.use(piniaPluginPersistedstate);

	window.pinia = pinia;

	// app.use(pinia)

	// return app.mount('#app-container')
};

// Execute async function
main().then(() => {
	console.log();

	addCookieEventListeners();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR active");
	});
}
